import DemandOffersService from "../services/DemandOffersService";
import reduxStore from "../redux/store";
import {setSaveStatusError} from "../redux/actions";
import Tr from "../translations/Translations";

const isResponseValidWithStoredPasswordCheck = (
    response, passwordSetSuccessCallback, passwordSetErrorCallback, setErrorsAndAlerts, skipShowError, clearErrorsSuccess) => {

    if (response.success === true) {
        if (response.hasOwnProperty("offerErrorsAndAlerts")) {
            setErrorsAndAlerts(response.offerErrorsAndAlerts);
        }
        if (clearErrorsSuccess){
            setErrorsAndAlerts([]);
        }
        return true;
    } else {
        if (response.noValidPassword) {
            DemandOffersService.openContractorPasswordPopup(passwordSetSuccessCallback, passwordSetErrorCallback)
        } else if (!skipShowError) {
            if (response?.errors && Object.keys(response.errors).length > 0){
                reduxStore.dispatch(setSaveStatusError(Tr(Object.values(response.errors)[0])));
            } else {
                reduxStore.dispatch(setSaveStatusError(Tr('bad_request_error')));
            }
        }
        if (setErrorsAndAlerts) {
            if (response.hasOwnProperty("offerErrorsAndAlerts")) {
                setErrorsAndAlerts(response.offerErrorsAndAlerts);
            } else if (!response.noValidPassword) {
                setErrorsAndAlerts(response.errors);
            }
        }
    }
    return false;
}

export default isResponseValidWithStoredPasswordCheck;